import { useMemo, useRef } from 'react';
/**
 * 更新前のstateを返す
 * @returns {React.MutableRefObject}
 */
export const usePrevious = (value) => {
    const ref = useRef();
    const prevRef = useRef();
    return useMemo(() => {
        if (ref.current !== value) {
            prevRef.current = ref.current;
            ref.current = value;
        }
        return prevRef.current;
    }, [value]);
};
